module.exports = __webpack_public_path__ + "img/7-5.f9eef704.png";